// The head every Recordings and dates tab shares: the eyebrow and heading, the grey Vimeo note and the
// 3 tabs (AdminRecordings.dc.html draws the note above the tabs; AdminWebinars.dc.html under them).
// Tabs follow the role: a host has only Cohorts and dates (their registers), and Webinars is owner,
// admin and support's (src/admin/shell/routes.js).
import { PageHeader, InfoNote, Tabs, adminPath } from '../ui/index.js'
import { COPY } from './copy.js'

export function tabsFor(role) {
  const all = [
    { key: 'recordings', label: COPY.tabs.recordings, to: adminPath.recordings() },
    { key: 'dates', label: COPY.tabs.dates, to: adminPath.dates() },
    { key: 'webinars', label: COPY.tabs.webinars, to: adminPath.webinars() },
  ]
  if (role === 'host') return all.filter(t => t.key === 'dates')
  return all
}

// note false leaves the tab's note out (the property strategy tool's completions, where Zoom doesn't apply)
export function ContentHead({ role, current, note: withNote = true }) {
  const note = !withNote ? null : current === 'webinars'
    ? <InfoNote icon="info">{COPY.webinarStrip}</InfoNote>
    : <InfoNote icon="video">{COPY.strip}</InfoNote>
  return (
    <>
      <PageHeader eyebrow={COPY.eyebrow} title={COPY.title} />
      {current !== 'webinars' && note}
      <Tabs label={COPY.tabsLabel} current={current} items={tabsFor(role)} />
      {current === 'webinars' && note}
    </>
  )
}

// A recording's chip in the list and the editor: Live, Tonight, After the session or Draft
export function StateChip({ chip, big = false }) {
  return <span className={`adc-chip adc-chip--${chip}${big ? ' adc-chip--big' : ''}`}>{COPY.chips[chip]}</span>
}

// The note under a Vimeo link box, in the board's 3 states
export function LinkNote({ link, id }) {
  const text = link.state === 'empty' ? COPY.linkEmpty : link.state === 'bad' ? COPY.linkBad : COPY.linkFound(link.id)
  return <p className={`adc-link-note${link.state === 'bad' ? ' adc-link-note--bad' : ''}`} id={id}>{text}</p>
}
